import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, signal, inject } from '@angular/core';
import { LOCAL_STORAGE_KEYS, PAGING_HEADERS } from '@app/app.constants';
import { LocalStorageService } from '@core/services/local-storage.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '@shared/components/toast-container/toast.service';
import { Logger } from '../services/logger.service';

@Injectable({
  providedIn: 'root',
})
export class CoreUtilsService {
  private toastService = inject(ToastService);
  private http = inject(HttpClient);
  private translate = inject(TranslateService);
  private localStorage = inject(LocalStorageService);

  private readonly log = new Logger(this.constructor.name);
  public tabletMode = signal(false);

  constructor() {
    this.tabletMode.set(
      this.localStorage.getKey(LOCAL_STORAGE_KEYS.tabletMode) === 'true'
    );
  }

  toggleTabletMode() {
    this.localStorage.setKey(
      LOCAL_STORAGE_KEYS.tabletMode,
      this.localStorage.getKey(LOCAL_STORAGE_KEYS.tabletMode) ? '' : 'true'
    );
    this.tabletMode.set(
      this.localStorage.getKey(LOCAL_STORAGE_KEYS.tabletMode) === 'true'
    );
  }

  showErrowMessage(message: string) {
    this.log.debug('show error message', message);
    this.toastService.danger(message, this.translate.instant('toastr.error'));
  }

  showSuccessMessage(message: string) {
    this.log.debug('show success message', message);
    this.toastService.success(message, '', 5000);
  }

  async getAllElements<T>(
    url: string,
    continuationToken: string = null,
    elements: T[] = [],
    params: HttpParams = new HttpParams()
  ): Promise<T[]> {
    let headers = new HttpHeaders();
    if (continuationToken) {
      headers = headers.append(
        PAGING_HEADERS.continuationToken,
        continuationToken
      );
    }
    const response = await this.http
      .get(url, { headers, observe: 'response', params })
      .toPromise();
    if (response.body) {
      const newElements = response.body as T[];
      elements = [...elements, ...newElements];
    }
    if (response && response.headers.has(PAGING_HEADERS.continuationToken)) {
      const newContinuationToken = response.headers.get(
        PAGING_HEADERS.continuationToken
      );
      return this.getAllElements<T>(
        url,
        newContinuationToken,
        elements,
        params
      );
    }
    return elements;
  }

  getPaymentTypesDisplayString(paymentTypes: string[]) {
    const translatedPaymentTypes: string[] = [];

    paymentTypes.map((pt) =>
      translatedPaymentTypes.push(this.translate.instant('paymentType.' + pt))
    );

    return translatedPaymentTypes.join(', ');
  }

  getRequestPasswordResetPayload(auth0domain: string, email: string) {
    return {
      email,
      domain: auth0domain,
      redirectTo: `${window.location.origin}`,
      senderEmail: 'donotreply@geneplanet.com',
      senderName: 'GenePlanet',
      subject: this.translate.instant('ACCOUNTS.RESET.EMAIL.SUBJECT'),
      title: this.translate.instant('ACCOUNTS.RESET.EMAIL.TITLE'),
      paragraph1: this.translate.instant('ACCOUNTS.RESET.EMAIL.PARAGRAPH1'),
      paragraph2: this.translate.instant('ACCOUNTS.RESET.EMAIL.PARAGRAPH2'),
      linkName: this.translate.instant('ACCOUNTS.RESET.EMAIL.LINK'),
      footer: this.translate.instant('ACCOUNTS.RESET.EMAIL.FOOTER'),

      supportEmail: this.translate.instant('ACCOUNTS.RESET.EMAIL.SUPPORTEMAIL'),
    };
  }

  getPriceContractForProduct(
    priceContracstList: any,
    productExternalId: string
  ): any {
    const priceContract = priceContracstList.filter(
      (p) => p.ident === productExternalId
    );

    return priceContract;
  }
}
